var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settings-engineers-audit-report" } },
    [
      _vm.hasPermission
        ? _c("div", { staticClass: "float-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: {
                  type: "button",
                  disabled: _vm.allOptionsChecked.bDisableExportBtn,
                },
                on: {
                  click: function ($event) {
                    return _vm.exportData()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.export")))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("label", { staticClass: "emphasis audit-report-header" }, [
        _vm._v(_vm._s(_vm.$t("settings.auditReportExport.title"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "check-type" }, [
        _c("input", {
          attrs: {
            id: "settings-engineers-audit-report-all",
            type: "checkbox",
          },
          domProps: { checked: _vm.allOptionsChecked.bMarkAllCheckBox },
          on: {
            change: function (event) {
              _vm.setAllOptionChecked(event.target.checked)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "audit-report-label",
            attrs: { for: "settings-engineers-audit-report-all" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("settings.auditReportExport.all")) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.exportOptions, function (item) {
        return _c("div", { key: item.key, staticClass: "check-type" }, [
          _c("input", {
            attrs: {
              id: "settings-engineers-audit-report-" + item.key,
              type: "checkbox",
            },
            domProps: { checked: item.checked },
            on: {
              change: function (event) {
                return (item.checked = event.target.checked)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "audit-report-label",
              attrs: { for: "settings-engineers-audit-report-" + item.key },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t(item.name)) + "\n    ")]
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }